import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=3bd24971&scoped=true"
import script from "./apply.vue?vue&type=script&lang=ts&route=%2Foffline%2Forder%2Fapply"
export * from "./apply.vue?vue&type=script&lang=ts&route=%2Foffline%2Forder%2Fapply"
import style0 from "./apply.vue?vue&type=style&index=0&id=3bd24971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd24971",
  null
  
)

export default component.exports